<ng-content select="[data-header]"></ng-content>
<ng-content select="[data-body]"></ng-content>
<ng-content select="[data-footer]"></ng-content>
